module.exports = __webpack_public_path__ + "img/eye-open.6fda4740.svg";